<app-dashboard-sidemenu></app-dashboard-sidemenu>


<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">
    <div *ngFor="let Content of breadcrumb;" class="breadcrumb-area">
        <h1>{{Content.title}}</h1>
        <ol class="breadcrumb">
            <li class="item">
                <a routerLink="/">Home</a>
            </li>
            <li class="item">
                <a routerLink="/dashboard">
                    {{Content.subTitle}}
                </a>
            </li>
            <li class="item">{{Content.title}}</li>
        </ol>
    </div>
    <div class="text-right add-listings-btn">
        <div class="form-group">

            <button type="submit" class="submit_btn m-0" (click)="sendtohealthcheckup()"
                *ngIf="role.roleName == 'Supplier' ||role.roleName ==='Admin'">
                Tool Health Checkup
            </button>
        </div>
    </div>
    <p-table #dt2 [value]="ToolListData" [rows]="10" responsiveLayout="scroll" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10,20,30,50]" [paginator]="true" currentPageReportTemplate="Showing {first} to
{last} of {totalRecords} entries" [filterDelay]="0"
        [globalFilterFields]="['businessUnit', 'supplierName','currencyName','packageNumber','orderNumber','jdecode','assetCode']">
        <ng-template pTemplate="caption">
            <div class="d-flex align-items-center " style="width: 100%;">

                <span class="p-input-icon-left d-flex align-items-center">
                    <i class="pi pi-search"></i>
                    <input [(ngModel)]="filterval" (input)="dt2.filterGlobal($event.target.value,
            'contains')" pInputText type="text" placeholder="Global Search">
                    <p-button (click)="reset(dt2)" type="button" class="ml-2" icon="bx bx-reset"></p-button>
                </span>

            </div>
        </ng-template>


        <ng-template pTemplate="header">
            <tr>
                <th>S.No.</th>
                <th>Action</th>
                <th style="text-align: center;">Tool Signed</th>
                <th style="text-align: center;">Tool Health Checkup</th>
                <th>Package Asset Code</th>
                <th>Tool Asset Code</th>
                <th>BU</th>
                <th>Business Unit</th>
                <th>PO Type</th>
                <th>PO No.</th>
                <!-- <th>Tool Description</th> -->
                <th>Supplier Name</th>
                <th>Supplier Code</th>
                <!-- <th>Asset Code</th>
            <th>Remarks</th> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tool let-i="rowIndex">
            <tr class="p-selectable-row">
                <td>{{i+1}}</td>
                <!-- <td class="d-flex" style="align-items: center;"> -->

                <!-- <button pButton pRipple type="button" 
                 pTooltip="Send Mail" icon="bx bxs-send"
                class="p-button-rounded p-button-primary p-button-text"></button>  -->
                <!-- </td> -->
                <!-- <td style="padding: 0.1rem 0.4rem!important;">
            <button pButton pRipple type="button" 
                icon="bx bx-check-circle" class="p-button-rounded p-button-success  p-button-text"></button>
            <button pButton pRipple type="button" 
                icon="pi pi-times-circle" class="p-button-rounded p-button-danger p-button-text"></button>
        </td> -->
                <!-- <td>{{tool.toolListId}}</td> -->
                <td>

                    <div class="delete-checkbox-onerow" style="display: flex; align-items: center;">
                        <ng-container
                            *ngIf="role.roleName === 'Admin' || role.roleName === 'Finance' || role.checker1 == true || role.roleName == 'Supplier'">
                            <input type="checkbox" [(ngModel)]="tool.selected" style="cursor: pointer;">
                        </ng-container>
                        <ng-container>
                            <button pButton pRipple icon="pi pi-external-link" *ngIf="role.checker1==true"
                                class="p-button-rounded p-button-info p-button-text"
                                (click)="onAprrovPress(tool.toolLoanDetailId)" pTooltip="Actions"
                                tooltipPosition="bottom"></button>
                                <button pButton pRipple type="button" (click)="openmodal(tool.toolLoanDetailId)"
							icon="bx bx-show" class="p-button-rounded p-button-primary p-button-text"></button>
                        </ng-container>
                    </div>


                </td>
                <!-- <td>
            <span class="product-badge status-Acknowledged" *ngIf="tool.documentSigned == true">
                Signed
              </span>
              <span class="product-badge status-" *ngIf="tool.documentSigned == false">
                Not Signed
              </span>
            </td> -->
                <td style="text-align: center;">
                    <span>
                        <span class="product-badge status-Acknowledged"
                            *ngIf="tool.documentSigned == true">Signed</span>
                        <span *ngIf="tool.documentSigned == false" class="product-badge status-">Not Signed</span>
                    </span>
                    <!-- <span *ngIf="!tool.documentSigned">
                    <span>-</span>
                </span> -->
                </td>
                <td style="text-align: center;">
                    <button pButton pRipple type="button" *ngIf="tool.toolhealthGenerated== true" [label]="'Completed'"
                        class="p-button-rounded
                p-button-success status_button" style="font-size:
                12px; padding:
                0.2rem 1rem;"></button>
                    <button pButton pRipple type="button" *ngIf="tool.toolhealthGenerated == false" [label]="'Pending'"
                        class="p-button-rounded
                status_button pending" style="font-size:
                12px; padding:
                0.2rem 1rem;"></button>
                </td>
                <td>{{tool.packageNumber ||'-'}}</td>
                   <td>{{tool.assetCode ||'-'}}</td>
                <!-- <td>{{tool.toolType ||'-'}}</td> -->
                <td>{{tool.bu || '-'}}</td>
                <td>
                    {{tool.businessUnit || '-'}}
                </td>
                <td>{{tool.poType || '-'}}</td>
                <td>
                    <span>{{tool.orderNumber|| '-'}}</span>
                </td>
                <!-- <td>
                <span>
                    {{tool.itemDescription }}
                </span>
            </td> -->
                <td>
                    <span>
                        {{tool.supplierName || '-' }}
                    </span>
                </td>
                <td> <span>{{tool.jdecode || '-' }}</span></td>

                <!-- <td>
                <span>
                    {{tool.assetCode }}
                </span>
            </td> -->

                <!-- <td>
                <span>{{tool.remark}}</span>
            </td> -->



            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">No data found.</td>
            </tr>
        </ng-template>
    </p-table>
    <app-dashboard-navbar></app-dashboard-navbar>
</div>

<p-dialog [(visible)]="checker1Modal" header="Checker 1 Verifcation" [modal]="true" [style]="{width: '45vw'}" [draggable]="false" [resizable]="false" >
    <div class="container authentication">
        <label for="remark">Remark</label>
        <textarea id="remark" type="text" [(ngModel)]="checker1remark" class="form-control"></textarea>
    </div>
    <br>
    <div class="col-lg-12">
        <div class="add-listings-btn" style="text-align: right">
            <button class="mr-2 success-btn" type="submit" (click)="btnClick('approve')"
                style="background: #40b340; color: white;">
                Approve
            </button>
            <button class="mr-2 reject-btn" type="submit" (click)="btnClick('reject')"
                style="background: #e34747; color: white;">
                Rework
            </button>
        </div>
    </div>
</p-dialog>
<p-dialog header="Health Checkup Data" [(visible)]="display" [modal]="true" [style]="{width: '50vw'}" [draggable]="false"
	[resizable]="false" >
    <p-table #dt4 [value]="healthcheckupdetails" class="mb-2" dataKey="id" responsiveLayout="scroll">
			<ng-template pTemplate="header">
				<tr>
					<th>S.No.</th>
                    <th>Supplier Name</th>
                    <th>Asset Code</th>
					<th>Avaiable At your facility</th>
					<th>Initial Estimated life</th>
					<th>Year of production start </th>
					<th>Qty Produced till Date</th>
					<th>Last prod. Dt/month</th>
					<th>Estimated life at present</th>
                    <th>Remarks</th>
                    <th>Tool Picture</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-customer let-i="rowIndex">
				<tr>
					<td>{{i+1}}</td>
					<td>
						<span>
							{{customer?.supplierName}}
						</span>
					</td>
                    	<td>
						<span>
							{{customer?.assetCode || '-'}}
						</span>
					</td>
					<td>
						<span>
							{{customer?.availableatyourfacility ||'-'}}
						</span>
					</td>
					<td>
						<span class="image-text">
							{{customer?.initialEstimatedLife || '-'}}
						</span>
					</td>
					<td>
						<span class="image-text">
							{{customer?.yearOfProductionStart ? customer?.yearOfProductionStart : '-'}}
						</span>
					</td>
					<td>
						<span class="image-text">
							{{customer?.otyProducedTillDate|| '-'}}
						</span>
					</td>
					<td>
						<span class="image-text">
							{{customer?.lastProducedMonth || '-'}}
						</span>
					</td>
                    	<td>
						<span class="image-text">
							{{customer?.estimatedLifeAtPresent || '-'}}
						</span>
					</td>
                    <td>
						<span class="image-text">
							{{customer?.remarks || '-'}}
						</span>
					</td>
                       <td>
						<!-- <span class="image-text">
							{{customer?.invoiceFileName || '-'}}
						</span> -->
                        <span><a [href]="customer.documentUrl" target="_blank"
                                    [download]="customer.documentUrl">Preview</a></span>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="5">No item found.</td>
				</tr>
			</ng-template>
		</p-table>
</p-dialog>